export default __webpack_public_path__ + "static/media/1278.84ea3a8d.png";